// libraries
import React from 'react';

// js
import colors from '../../../styles/colors';
import {
    TitleFormat,
    ContainerDivider,
    // ButtonAction,
    TextAction,
    ContainerSelect,
    Option,
    ViewSelects,
} from './dashOperationStyles';

// interfaces
import { DataAuthorsInterface } from '../../../interfaces';
import { InitialFiltersInterfaces } from './dashOperationInterfaces';

const RenderTitle = (
    title: string,
    allAuthors: Array<DataAuthorsInterface>,
    author: string,
    setAuthor: (v: string) => void,
    allFilters: InitialFiltersInterfaces,
    setAllFilters: (v: InitialFiltersInterfaces) => void,
): React.ReactElement | null => {
    const onChangeFormat = (txt: React.ChangeEvent<HTMLSelectElement>) => {
        const FormatSplit = txt.target.value.split(',');
        setAuthor(FormatSplit[1]);
        setAllFilters({ ...allFilters, nameAuthor: FormatSplit[1] });
    };

    const RemoveAuthor = () => {
        setAuthor('');
        setAllFilters({ ...allFilters, nameAuthor: '' });
    };

    const RenderAuthors = () => allAuthors.map(v => <Option value={`${v.id},${v.name}`}>{v.name}</Option>);

    if (title === 'Novos usuários' || title === 'Download do aplicativo') {
        return <TitleFormat>{title}</TitleFormat>;
    }
    if (title === 'Streaming reproduzidos') {
        // const onChangeFilterStreamingMonth = () => {
        //     setAllFilters({
        //         ...allFilters,
        //         filterStreaming: 'month',
        //     });
        // };
        // const onChangeFilterStreamingYear = () => {
        //     setAllFilters({
        //         ...allFilters,
        //         filterStreaming: 'year',
        //     });
        // };
        return (
            <ContainerDivider>
                <ContainerDivider>
                    <TitleFormat>{title}</TitleFormat>
                    {/*
                        <ButtonAction
                        backgroundColor={allFilters.filterStreaming === 'month' ?
                        colors.basic.grayLight : colors.basic.white}
                        onClick={onChangeFilterStreamingMonth}>
                            <TextAction
                            cursor="pointer"
                            color={allFilters.filterStreaming !== 'month' ?
                            colors.basic.grayLight : colors.basic.white}>Mensal</TextAction>
                        </ButtonAction>
                    */}
                    {/*
                        <ButtonAction
                            backgroundColor={allFilters.filterStreaming === 'year' ?
                            colors.basic.grayLight : colors.basic.white}
                            onClick={onChangeFilterStreamingYear}
                        >
                            <TextAction
                                cursor="pointer"
                                color={allFilters.filterStreaming !== 'year' ?
                                colors.basic.grayLight : colors.basic.white}
                            >
                                Anual
                            </TextAction>
                        </ButtonAction>
                    */}
                </ContainerDivider>
            </ContainerDivider>
        );
    }

    if (title === 'Desempenho dos autores') {
        return (
            <ContainerDivider alignItems="flex-start">
                <TitleFormat>{title}</TitleFormat>
                <ContainerDivider flexDirection="column">
                    <ContainerSelect onChange={onChangeFormat} value="">
                        <Option value="">Selecione o autor</Option>
                        {RenderAuthors()}
                    </ContainerSelect>
                    {author.length ? (
                        <ContainerDivider width="250px">
                            <ViewSelects>
                                <TextAction color={colors.basic.white} marginRight="10px">
                                    {author}
                                </TextAction>
                                <TextAction
                                    color={colors.basic.white}
                                    onClick={RemoveAuthor}
                                    fontSize="12px"
                                    cursor="pointer"
                                >
                                    X
                                </TextAction>
                            </ViewSelects>
                        </ContainerDivider>
                    ) : null}
                </ContainerDivider>
            </ContainerDivider>
        );
    }

    return null;
};

export default {
    RenderTitle,
};
